import artifact from '$houdini/artifacts/UpdateUserTripPreferences'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateUserTripPreferencesStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
